export class WalletRouterUtils {
    /**
     * Formats the router for the deep links on parents
     * ? = _
     * = equals .
     * @param router The router
     */
    static formatRouter(router) {
        return router.replace(/[?]/g, '_').replace(/[=]/g, '.');
    }
    /**
     * unformats the router
     * _ = ?
     * . equals =
     * @param router The router
     */
    static unformatRouter(router) {
        return router.replace(/[_]/g, '?').replace(/[.]/g, '=');
    }
}
//# sourceMappingURL=wallet-router-utils.js.map